import iconTemplate from './IconTemplate.jsx';

export default iconTemplate(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 14 14"
        id="Magnifying-Glass--Streamline-Flex"
    >
        <desc>
            {'Magnifying Glass Streamline Icon: https://streamlinehq.com'}
        </desc>
        <g id="magnifying-glass--glass-search-magnifying">
            <path
                id="Vector"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m13.2503 13.25 -2.2357 -2.2356"
                strokeWidth={1}
            />
            <path
                id="Vector_2"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6.62499 12.5C10.385 12.5 12.5 10.385 12.5 6.62499 12.5 2.865 10.385 0.75 6.62499 0.75 2.865 0.75 0.75 2.865 0.75 6.62499 0.75 10.385 2.865 12.5 6.62499 12.5Z"
                strokeWidth={1}
            />
        </g>
    </svg>,
);
